import label from './funnel.emphasis.label'
import labelLine from './funnel.emphasis.labelLine'
import itemStyle from './funnel.emphasis.itemStyle'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "高亮的标签和图形样式。",
  type: "object",
  props: {
    label,
    labelLine,
    itemStyle,
  },
}
